export const CallResponseSubmitted = "Call Response Submitted Successfully.";
